import script from "./Services.vue?vue&type=script&setup=true&lang=ts"
export * from "./Services.vue?vue&type=script&setup=true&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=3b0d9574&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0d9574"]])

export default __exports__